import React, { Fragment } from 'react'

import isEqual from 'lodash/isEqual'

import {
  GoogleNativeAdDesktop,
  GoogleNativeAdMobile,
} from 'components/atoms/googleNativeAd'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { NATIVE_ADS_LOCALE } from 'interfaces/constants/nativeAd'
import { Article } from 'interfaces/types'
import { getAdTag, getCountryAdTag, getLocaleCategoryAdTag } from 'utils/ads'

import { StyledExploreCategory } from './index.styled'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { AdBlock } from '../adBlock'
import { AdBlockContainer } from '../adBlock/adBlockContainer'
import { ArticleCardWrapper } from '../articleCardWrapper'

type Props = {
  posts: Array<Article>
  categoryInfo?: {
    permalink: string
    termId: string
  }
}

const ExploreCategory = ({ posts, categoryInfo }: Props) => {
  const { query, locale, asPath } = useRouterExtend()
  const handleClickSameCategory = (e: React.MouseEvent) => {
    e.preventDefault()
  }
  const isMobile = useIsMobile()
  const adUnitPathMobile = getAdTag({
    countryAdTag: getCountryAdTag(locale, {
      isMobile: true,
    }),
    contentAdTag: getLocaleCategoryAdTag(locale, asPath.split('?')[0]),
  })

  return (
    <StyledExploreCategory>
      {posts.map((post, index) => {
        const slugExplainerCategory = post.category.permalink
          .split('/')
          .filter(Boolean)

        const isSameCategory = isEqual(query.slug, slugExplainerCategory)

        return (
          <Fragment key={post.id}>
            <div className="wrapper">
              <ArticleCardWrapper
                className={`article-card ${
                  isSameCategory && 'no-replace-click'
                }`}
                key={index}
                type="author"
                size="md"
                direction="horizontal"
                article={post}
                onClickCategoryName={
                  isSameCategory ? handleClickSameCategory : () => undefined
                }
              />

              {index === posts.length - 1 ? '' : <hr className="line" />}
            </div>
            {index === 1 &&
              NATIVE_ADS_LOCALE.includes(locale) &&
              (isMobile ? <GoogleNativeAdMobile /> : <GoogleNativeAdDesktop />)}
            {index === 3 && isMobile && (
              <AdBlockContainer>
                <AdBlock
                  adUnitPath={adUnitPathMobile}
                  size={[
                    [300, 250],
                    [300, 600],
                  ]}
                  divId={'div-gpt-ad-midbanner2-mobile-' + categoryInfo?.termId}
                  pos={['MidBanner2']}
                />
              </AdBlockContainer>
            )}
          </Fragment>
        )
      })}
    </StyledExploreCategory>
  )
}

export { ExploreCategory }
